import React, { Component, Fragment, ReactElement, SyntheticEvent } from 'react'

import Button from '@vtex/styleguide/lib/Button'
import IconCaretDown from '@vtex/styleguide/lib/icon/CaretDown'
import IconCaretUp from '@vtex/styleguide/lib/icon/CaretUp'
import Menu from './Menu'

export type MenuOption = {
  label: string | ReactElement
  onClick: () => void
}

type Props = {
  shouldCloseOnClick: boolean
  isSimpleIcon: boolean
  icon: JSX.Element
  showCaretIcon: boolean
  boxWidth: string | number
  options: MenuOption[]
  label?: string
  align?: 'right' | 'left'
  iconAlign?: 'right' | 'left'
  buttonVariation?: 'primary' | 'secondary' | 'tertiary'
  classNames?: string
  buttonSize?: 'small' | 'regular' | 'large'
}

type State = {
  isBoxOpen: boolean
  isHoveringButton: boolean
}

class ActionMenu extends Component<Props, State> {
  menuBtnRef: React.RefObject<typeof Button>

  constructor(props: Props) {
    super(props)
    this.menuBtnRef = React.createRef()
    this.state = {
      isBoxOpen: false,
      isHoveringButton: false,
    }
  }

  handleClick = () => {
    const { isBoxOpen } = this.state
    if (isBoxOpen) {
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      document.removeEventListener('mousedown', this.handleClickOutside)
    } else {
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      document.addEventListener('mousedown', this.handleClickOutside)
    }
    this.setState({ isBoxOpen: !isBoxOpen })
  }

  handleClickOutside = (e: SyntheticEvent) => {
    if (
      this.menuBtnRef &&
      this.menuBtnRef.current &&
      !this.menuBtnRef.current.contains(e.target) &&
      this.state.isBoxOpen
    ) {
      this.handleClick()
    }
  }

  handleHover = (isHovering: boolean) => {
    const { isBoxOpen, isHoveringButton } = this.state
    if (!isBoxOpen || isHovering !== isHoveringButton) {
      this.setState({ isHoveringButton: isHovering })
    }
  }

  render() {
    const {
      icon,
      label,
      options = [],
      boxWidth,
      align = 'right',
      isSimpleIcon,
      showCaretIcon = true,
      shouldCloseOnClick,
      iconAlign = 'left',
      buttonVariation = '',
      classNames = '',
      buttonSize = 'small',
    } = this.props

    const { isBoxOpen, isHoveringButton } = this.state

    const iconMenu = icon && (
      <div className="action-menu-icon" onClick={this.handleClick}>
        {icon}
      </div>
    )

    const iconCaret = isBoxOpen ? (
      <IconCaretUp size={13} color="currentColor" />
    ) : (
      <IconCaretDown size={13} color="currentColor" />
    )

    const buttonMenu = (
      <Button
        variation={
          buttonVariation ||
          (isBoxOpen || isHoveringButton ? 'secondary' : 'tertiary')
        }
        size={buttonSize}
        onMouseOver={() => this.handleHover(true)}
        onMouseOut={() => this.handleHover(false)}
        onClick={this.handleClick}
      >
        <span
          className={`flex align-baseline items-center ${
            !showCaretIcon && iconAlign === 'right' ? 'flex-row-reverse' : ''
          }`}
        >
          {icon && (
            <div className={`self-center ${showCaretIcon ? 'mr2' : ''}`}>
              {icon}
            </div>
          )}

          {label && (
            <span className={`nowrap ${showCaretIcon ? 'mr3' : ''}`}>
              {label}
            </span>
          )}

          {showCaretIcon && iconCaret}
        </span>
      </Button>
    )

    return (
      <Fragment>
        <div
          ref={this.menuBtnRef}
          className={`pointer flex items-center justify-center br2 hover-bg-light-silver ${classNames}`}
        >
          <div
            className={`flex ${
              align === 'left' ? 'justify-start' : 'justify-end'
            }`}
          >
            {isSimpleIcon ? iconMenu : buttonMenu}
          </div>
          <Menu
            isOpen={isBoxOpen}
            align={align}
            boxWidth={boxWidth}
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'import("/Users/guilhermeheynemannbruzzi/proj... Remove this comment to see the full error message
            options={options}
            // @ts-expect-error ts-migrate(2322) FIXME: Type '(() => void) | null' is not assignable to ty... Remove this comment to see the full error message
            onMenuClose={shouldCloseOnClick ? this.handleClick : null}
          />
        </div>
      </Fragment>
    )
  }
}

export default ActionMenu
